import { Expose, Type } from "class-transformer";
import { Asset } from "src/containers/household-claim/screens/declaration/declaration";

import { BaseModel } from "src/shared/models/base.model";

export class HouseholdClaimBooking extends BaseModel {
    @Expose() address = "";
    @Expose() claimDate = "";
    @Expose() email = "";
    @Expose() productCode = "";
    @Expose() productName = "";
    @Expose() policyId = -1;
    @Expose() policyNumber = -1;
    @Expose() policyCurrency = "";
    @Expose() detail = "";
    @Expose() phoneNumber = "";
    @Expose() saveDuplicate = false;
    @Expose() adjusterId = "";
    @Expose()
    assets: Asset[] = [];
    @Expose()
    @Type(() => Number)
    coverageIds: number[] = [];
}
